module.exports = __webpack_public_path__ + "img/q4.055ad9b6.svg";